import React from 'react';

export const CandidatePortalEditor = (): JSX.Element => {
  return <div>Candidate Portal Editor</div>;
};
